import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A road traffic signal: a black three-aspect head with red, amber and green
// lenses under visor hoods, on a backplate and a grey pole, with a short side
// arm. An everyday powered fixture.
const POLE = "#6c727a";
const HEAD = "#2a2d31";
const PLATE = "#1f2226";
const RED = "#d23b2f";
const AMBER = "#f0a52e";
const GREEN = "#3fae5a";

export const trafficLight = defineModel({
  id: "traffic-light",
  batchId: "electric",
  name: "Traffic light",
  tags: ["prop", "electric", "power", "lighting", "signal", "traffic"],
  summary: "A three-aspect traffic signal on a pole.",
  footprint: 0.3,
  parts(): Part[] {
    const parts: Part[] = [
      // Base, pole and side arm.
      { geometry: new THREE.CylinderGeometry(0.1, 0.12, 0.08, 10), color: "#5a5a5e", position: [0, 0.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.055, 1.5, 10), color: POLE, position: [0, 0.78, 0] },
      { geometry: new THREE.BoxGeometry(0.36, 0.05, 0.05), color: POLE, position: [0.2, 1.5, 0] },
      // Backplate and signal head.
      { geometry: new THREE.BoxGeometry(0.26, 0.62, 0.03), color: PLATE, position: [0, 1.1, 0.04] },
      { geometry: new THREE.BoxGeometry(0.2, 0.56, 0.14), color: HEAD, position: [0, 1.1, 0.1] },
    ];
    // Three lenses with visor hoods.
    const lenses: [number, string][] = [[1.32, RED], [1.1, AMBER], [0.88, GREEN]];
    for (const [y, c] of lenses) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.04, 12), color: c, position: [0, y, 0.18], rotation: [Math.PI / 2, 0, 0] });
      parts.push({ geometry: new THREE.BoxGeometry(0.14, 0.03, 0.06), color: HEAD, position: [0, y + 0.06, 0.19], rotation: [0.3, 0, 0] });
    }
    return parts;
  },
  animations: [],
});
